import {BrowserRouter, Routes, Route, data} from "react-router-dom"
import { useEffect, useState } from "react"
import { getDataFromCMS } from "../../service/service"
import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import HomePage from "../../pages/HomePage/HomePage"
import ModalWindow from "../Modal/ModalWindow"
import OneProjectPage from "../../pages/OneProjectPage/OneProjectPage"
import AllPortfolio from "../../pages/PortfolioPage/AllPortfolio"
import AboutMe from "../../pages/AboutMePage/AboutMe"
import BlogPage from "../../pages/BlogPage/BlogPage"
import ArticlePage from "../../pages/ArticlePage/ArticlePage"
import FeedbackForm from "../FeedbackForm/FeedbackForm"

const App = () => {
    const [portfolioData, setPortfolioData] = useState(null)
    const [isOpenModal, setOpenModal] = useState(false)

useEffect(() => {
   getDataFromCMS("portfolio").then((data) => {
        if (Array.isArray(data)) setPortfolioData(data)
   }).catch(() => {})

}, [])

return(
    <BrowserRouter>
    <Header setOpenModal={setOpenModal} />
    <Routes>
    <Route path="/" element={ <HomePage setOpenModal={setOpenModal} portfolioData={portfolioData} />} />
    <Route path="/portfolio" element={ <AllPortfolio portfolioData={portfolioData} />} />
    <Route path="/portfolio/:link" element={ <OneProjectPage portfolioData={portfolioData} />} />
    <Route path="/about-me" element={<AboutMe />} />
    <Route path="/blog" element={<BlogPage />} />
    <Route path="/blog/:link" element={<ArticlePage />} />
    </Routes>
    <Footer />

    <ModalWindow isOpenModal={isOpenModal} setOpenModal={setOpenModal} element={<FeedbackForm setOpenModal={setOpenModal }/>} />

    </BrowserRouter>
)
}
export default App